// Where the router guard sends a user who may not open `to`, or undefined to let them through.
export function redirectFor(to, getters) {
  const needs = (key) => to.matched.some((record) => record.meta[key]);
  if (needs('requiresAuth')) {
    if (!getters.isLoggedIn) return { name: 'login' };
    if (needs('requiresSuperAdmin') && !getters.isSuperAdmin) return { name: 'sources' };
  } else if (needs('requiresVisitor') && getters.isLoggedIn) {
    return { name: 'connections' };
  }
  return undefined;
}
